import { getEnv } from '@/helpers/environment'

export function setDocumentTitle(title?: string) {
  const portal = getEnv().portal
  document.title = title ? `${stripTrustedHTML(title)} — ${portal.name}` : portal.name
}

/**
 * This must not be used to sanitize untrusted content. Any malicious payloads in the input will be executed.
 */
export function stripTrustedHTML(html: string): string {
  const escape = document.createElement('div')
  escape.innerHTML = html

  // Trello: https://trello.com/c/ZfIJ9yz9
  // `innerHTML` can be `undefined` based on the error on TrackJS
  // https://my.trackjs.com/shared/MzQzYWQ5Y2Y2ZTY1NDE3MmI2MTg3OTFlNzUwOTc1MWQ.
  // Possibly, this only occurs on really old browsers. However, we couldn't
  // replicate this on BrowserStack using the same OS and Browser combinations
  // shown in TrackJS.
  if (escape.innerText == null) {
    /* eslint-disable no-console */
    console.log('stripHTML(): HTMLElement.innerText is not defined')
  }
  return escape.innerText ?? ''
}
